<template>
  <footer>
    <div class="bg-light-gray">
      <div class="footer-grid container">
        <section class="footer-grid__logo">
          <div class="text-center">
            <Link
              href="/"
              class="text-center"
              aria-label="Retire path logo link to home page">
              <svg
                class="footer__logo"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xml:space="preserve"
                viewBox="0 0 303 51.4"
                title="Retire path logo">
                <defs><path id="a" d="M0 0h303v51.4H0z" /></defs>
                <clipPath id="b">
                  <use xlink:href="#a" overflow="visible" />
                </clipPath>
                <g clip-path="url(#b)">
                  <text
                    fill="#003a70"
                    font-family="Helvetica"
                    font-size="5"
                    transform="translate(293.192 4.351)">
                    SM
                  </text>
                </g>
                <path
                  fill="#003a70"
                  d="m278.5.8 10.6 27.5h-5l-2.8 7.9H303L289.6.8h-11.1z" />
                <path
                  fill="#e67300"
                  d="m266 34.8-5.5 15h11l18-48.9h-11.4L266 34.8z" />
                <path
                  fill="#003a70"
                  d="M260.5 49.8h11.1L258 14.4h-10.9l13.4 35.4z" />
                <g>
                  <defs><path id="c" d="M0 0h303v51.4H0z" /></defs>
                  <clipPath id="d">
                    <use xlink:href="#c" overflow="visible" />
                  </clipPath>
                  <g clip-path="url(#d)">
                    <path
                      fill="#003a70"
                      d="M7.4 39.2H0V14.4h7.4v6c1.3-4.6 4.5-6.5 7-6.5 1.5 0 2.9.3 4.3.9l-1.3 6.6c-1.2-.5-2.5-.8-3.8-.7-4.3 0-6.2 3.3-6.2 9.9v8.6zM44.2 34.7c-2.5 3.7-7.1 5-11.3 5-7 .2-12.8-5.3-13-12.3v-.7c0-7.8 5.8-12.9 13-12.9 7.1 0 12.7 5.3 12.7 13.1 0 .6-.1 1.6-.1 2.3H27.3c.4 2.9 3.5 4.1 6.1 4.1 2.1.1 4.1-.8 5.4-2.3l5.4 3.7zm-6.1-10.1c-.4-2.5-2.6-4.4-5.2-4.3-2.6-.1-5 1.7-5.5 4.3h10.7zM64.6 14.4v5.8h-5.2v19H52v-19h-4.5v-5.8H52V4.9h7.3v9.5h5.3zM68.6 14.4H76v24.8h-7.3V14.4zM89.4 39.2H82V14.4h7.4v6c1.3-4.6 4.5-6.5 7-6.5 1.5 0 2.9.3 4.3.9l-1.3 6.6c-1.2-.5-2.5-.8-3.8-.7-4.3 0-6.2 3.3-6.2 9.9v8.6zM126.2 34.7c-2.5 3.7-7.1 5-11.3 5-7 .2-12.8-5.3-13-12.3v-.7c0-7.8 5.8-12.9 13-12.9 7.1 0 12.7 5.3 12.7 13.1 0 .6-.1 1.6-.1 2.3h-18.2c.4 2.9 3.5 4.1 6.1 4.1 2.1.1 4.1-.8 5.4-2.3l5.4 3.7zm-6.1-10.1c-.4-2.5-2.6-4.4-5.2-4.3-2.6-.1-5 1.7-5.5 4.3h10.7z" />
                    <path
                      fill="#e67300"
                      d="M141.5 14.4v3.1c1.2-2.3 4.2-3.6 7.3-3.6 6.4 0 12 5 12 12.9 0 8-5.6 13-12 13-3.1 0-6.1-1.3-7.3-3.6v15.2h-7.3v-37h7.3zm5.9 18.4c3.1 0 5.7-2.4 5.7-5.6v-.3c.2-3.1-2.2-5.8-5.4-6h-.4c-3.2 0-5.8 2.6-5.7 5.8v.2c-.2 3.1 2.2 5.7 5.3 5.9h.5M183.8 36.4c-1.6 2.4-5.3 3.3-7.2 3.3-7 0-12.7-5.7-12.7-12.7v-.2c-.1-7 5.4-12.8 12.4-12.9h.2c1.6 0 5.3.5 7.2 3.3v-2.8h7.3v24.8h-7.3v-2.8zm-6.1-3.7c3.3 0 5.9-2.6 5.9-5.9s-2.6-5.9-5.9-5.9c-3.3-.1-6.1 2.6-6.2 5.9.1 3.3 2.9 6 6.2 5.9M211.9 14.4v5.8h-5.2v19h-7.3v-19h-4.5v-5.8h4.5V4.9h7.3v9.5h5.2zM223.6 39.2h-7.4V.9h7.4v17.4c1-3.1 4.6-4.4 7-4.4 6.5 0 9.9 4.4 9.9 11.9v13.5h-7.4V26c.2-2.6-1.8-4.8-4.3-4.9h-.3c-2.3 0-4.9 1.3-4.9 5v13.1z" />
                  </g>
                </g>
              </svg>
            </Link>
          </div>
        </section>
        <section class="footer-grid__nav">
          <nav class="footer-nav">
            <ul>
              <li>
                <Link :href="'/employers/'">Employers</Link>
              </li>
              <li>
                <Link :href="'/savers/'">Savers</Link>
              </li>
              <li>
                <Link :href="'/resources/about/'">About</Link>
              </li>
              <li>
                <Link :href="'/resources/news/'">Newsroom</Link>
              </li>
              <li>
                <Link :href="'/contact/subscribe/'">Subscribe</Link>
              </li>
              <li>
                <a href="https://www.commonwealthsavers.com/careers">Careers</a>
              </li>
            </ul>
          </nav>
        </section>

        <section class="footer-grid__legal">
          <nav class="footer-legal">
            <ul>
              <li>
                <a :href="'/resources/download/program-description'">
                  Program Description
                </a>
              </li>
              <li>
                <Link :href="'/legal/disclosure'">Disclosure</Link>
              </li>
              <li>
                <Link :href="'/legal/terms-use'">Terms of Use</Link>
              </li>
              <li>
                <Link :href="'/legal/privacy-policy'">Privacy Policy</Link>
              </li>
              <li>
                <a
                  href="https://secure.ethicspoint.com/domain/media/en/gui/49911/index.html">
                  Feedback
                </a>
              </li>
              <li>
                <Link :href="'/legal/ada-notice'">ADA Notice</Link>
              </li>
              <li>
                <a
                  href="https://www.commonwealthsavers.com/download/commonwealth-foia-request">
                  FOIA Request
                </a>
              </li>
              <li>
                <a
                  href="https://www.commonwealthsavers.com/resources/reports-investment-policies">
                  Reports
                </a>
              </li>
            </ul>
          </nav>
        </section>

        <section class="footer-grid__state-seal flex items-center md:items-start">
          <LogoVaState
            class="mx-auto h-28 w-28 sm:h-32 sm:w-32 md:h-40 md:w-40"></LogoVaState>
        </section>

        <section class="footer-grid__contact">
          <address class="address">
            <p><strong>Employer Assistance</strong><br /> 1-833-608-6281</p>
            <p><strong>Saver Assistance</strong><br /> 1-833-608-6776</p>
            <p><Link :href="'/contact/'">Send us a message</Link></p>
          </address>
        </section>

        <section class="footer-grid__social">
            <ul class="social flex justify-center gap-20px list-none m-0 p-0">
            <li>
                <a href="https://www.facebook.com/RetirePathVA">
                <svg class="w-7 h-7" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" style="enable-background:new 0 0 100 100" viewBox="0 0 100 100"><path d="M97 50.1C97 24.1 75.9 3 49.9 3S2.7 24.1 2.7 50.1c0 23.2 16.9 42.9 39.8 46.6V63.8h-12V50.1h12V39.8c0-11.8 7-18.3 17.8-18.3 3.5 0 7.1.4 10.6.9V34h-6c-3.7-.5-7.2 2.1-7.7 5.9-.1.5-.1 1 0 1.5v8.8h13.1l-2.1 13.6h-11v32.9C80.1 93.1 97 73.3 97 50.1z" /></svg>
                <span class="sr-only">Our facebook account</span>
                </a>
            </li>
            <li>
                <a class="" href="https://www.instagram.com/retirepathva">
                <svg class="w-7 h-7" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" style="enable-background:new 0 0 100 100" viewBox="0 0 100 100"><path d="M30.5 3.3c-3.9.1-7.8.8-11.4 2.2C12.8 8 7.8 13 5.4 19.3 4 22.9 3.3 26.8 3.2 30.7c-.2 5-.2 6.6-.2 19.4s.1 14.4.3 19.4c.1 3.9.8 7.8 2.2 11.4C8 87.2 13 92.2 19.3 94.6c3.7 1.4 7.5 2.1 11.4 2.2 5 .2 6.6.3 19.4.2s14.4-.1 19.4-.3c3.9-.1 7.8-.8 11.4-2.2C87.2 92 92.2 87 94.6 80.7c1.4-3.7 2.1-7.5 2.2-11.4.2-5 .3-6.6.2-19.4 0-12.8-.1-14.4-.3-19.4-.1-3.9-.8-7.8-2.2-11.4-1.2-3.1-3-6-5.4-8.3-2.4-2.4-5.2-4.2-8.3-5.4-3.7-1.4-7.5-2.1-11.4-2.2C64.3 3 62.7 3 49.9 3s-14.3.1-19.4.3m.6 85c-3 0-5.9-.6-8.7-1.6-2-.8-3.9-1.9-5.4-3.5-1.6-1.5-2.8-3.4-3.5-5.4-1-2.8-1.6-5.7-1.6-8.7-.2-5-.3-6.4-.3-19s0-14 .2-19c0-3 .6-5.9 1.6-8.7.7-2 1.9-3.9 3.5-5.4 1.5-1.6 3.4-2.8 5.4-3.5 2.8-1 5.7-1.6 8.7-1.6 5-.2 6.4-.3 19-.3s14 0 19 .2c3 0 5.9.6 8.7 1.6 4.1 1.6 7.4 4.8 8.9 8.9 1 2.8 1.6 5.7 1.6 8.7.2 5 .3 6.4.3 19 0 12.5 0 14-.3 19 0 3-.6 5.9-1.6 8.7-1.6 4.1-4.8 7.3-8.9 8.9-2.8 1-5.7 1.6-8.7 1.6-5 .2-6.4.3-19 .3-12.5.1-14 0-18.9-.2m38.3-63.4c0 3.1 2.5 5.6 5.7 5.6 3.1 0 5.6-2.5 5.6-5.7 0-3.1-2.5-5.6-5.7-5.6-3.1 0-5.6 2.5-5.6 5.7M25.9 50c0 13.3 10.9 24.1 24.2 24.1 13.3 0 24.1-10.9 24.1-24.2 0-13.3-10.9-24.1-24.2-24.1-13.4.1-24.2 10.9-24.1 24.2m8.4 0c0-8.7 7-15.7 15.6-15.7 8.7 0 15.7 7 15.7 15.6s-7 15.7-15.6 15.7c-8.6.1-15.6-6.9-15.7-15.6"/></svg>
                <span class="sr-only">Our instagram account</span>
                </a>
            </li>
            <li>
                <a href="https://x.com/retirepathva">
                <svg class="w-7 h-7" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 1226.4"><path d="M714.2,519.3L1160.9,0h-105.9l-387.9,450.9L357.3,0H0l468.5,681.8L0,1226.4h105.9l409.6-476.2,327.2,476.2h357.3l-485.9-707.1h.1ZM569.2,687.8l-47.5-67.9L144,79.7h162.6l304.8,436,47.5,67.9,396.2,566.7h-162.6l-323.3-462.4h0v-.1Z"></path></svg>
                <span class="sr-only">Our X account</span>
                </a>
            </li>
            <li>
                <a href="https://www.youtube.com/@RetirePathVA">
                <svg class="w-7 h-7" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" style="enable-background: new 0 0 45.9 32.2" viewBox="0 0 45.9 32.2"><path d="M21.6 30.5c-5.3 0-9.8-.3-13.1-.8C5 29.2 3 28.3 2 27c-.9-1.3-1-3.1-1-5.4V9.5c0-2.4.5-4 1.5-5.2 1.1-1.4 3.1-2.3 6.1-3 2.8-.6 7.6-1 13.3-1 5.9 0 11.8.4 15.5 1 3.3.6 5.3 1.4 6.3 2.8 1 1.3 1.2 3 1.2 5.4v12.1c0 2.6-.2 4.3-1.1 5.5-1 1.4-3 2.2-6.4 2.6-4.4.5-10.3.8-15.8.8z" class="icon" transform="translate(0 .674)"></path><path d="M21.9 1.3c-5.6 0-10.4.4-13.1 1-2.8.6-4.5 1.5-5.5 2.6C2.4 5.9 2 7.3 2 9.5v12.1c0 2.4.1 3.8.8 4.8.8 1.1 2.7 1.9 5.9 2.4s7.7.8 12.9.8c5.4 0 11.3-.3 15.8-.8 1.7-.2 3-.5 4-.9.8-.3 1.3-.7 1.7-1.3.7-1 .9-2.6.9-4.9V9.5c0-2.1-.2-3.7-1-4.7-.9-1.1-2.7-1.9-5.7-2.4-3.7-.7-9.6-1.1-15.4-1.1m0-2c5.8 0 11.8.4 15.7 1C45 1.5 46 4.4 46 9.4v12.1c0 5-.6 8.2-8.4 9.1-7.7.9-21.3 1.3-29.2 0s-8.4-4-8.4-9V9.5c0-5 1.9-7.6 8.4-9.1 3-.8 8.2-1.1 13.5-1.1z" class="icon" transform="translate(0 .674)"></path><path d="M640.6 4710.9c.5.2.7.8.5 1.3-.1.2-.3.4-.5.5l-14.5 6.1c-.5.2-1.1 0-1.3-.5-.1-.1-.1-.3-.1-.4v-12.3c0-.6.4-1 1-1 .1 0 .3 0 .4.1l14.5 6.2z" style="fill: #fff" transform="translate(-608 -4696.41)"></path></svg>
                <span class="sr-only">Our youtube account</span>
                </a>
            </li>
            </ul>
        </section>

      </div>
    </div>

    <section class="copyright">
      <div>
        <p>
          &copy;{{ year }} RetirePath Virginia. All Rights Reserved. RetirePath
          Virginia is managed by
          <a href="https://www.commonwealthsavers.com/"
            >Commonwealth Savers Plan</a
          >.
        </p>
      </div>
    </section>
  </footer>
</template>

<script>
import { Link } from "@inertiajs/vue3";
import LogoVaState from "./Svgs/Logos/LogoVaState.vue";

export default {
  components: {
    Link,
    LogoVaState,
  },

  setup() {
    const year = new Date().getFullYear();

    return { year };
  },
};
</script>
